import { motion } from "framer-motion";
import {
  ChartBarIcon,
  SparklesIcon,
  UserGroupIcon,
  PresentationChartLineIcon,
  AcademicCapIcon,
  BriefcaseIcon, // 23 Nov 2025
} from "@heroicons/react/24/outline";

export default function EtEternityPractice() {

  // First Created - 22 Nov 2025
  // Author - Atul Pandey
  // Purpose — Et Practices
  // Updated - 22 Nov 2025 - Cinematic Advisory Section — Calm, Premium, Strategic
  // Updated - 22 Nov 2025 - Polished Visual Upgrade
  // Updated - 23 Nov 2025 - Refined Copy and Sales Cohort

//   const items = [
//     "Growth Performance Diagnostics",
//     "Executive Clarity Workshops",
//     "1:1 Founder / CXO Growth Advisory",
//     "Portfolio-company interventions for PE firms",
//     "Cohort-based leadership programs",
//   ];

    // const items = [
    //     "Growth Performance Diagnostics for tech-services and consulting firms.",
    //     "Executive Clarity Workshops for founders, CXOs, and business unit leaders.",
    //     "1:1 Leadership Advisory to help leaders think clearer and operate with purpose.",
    //     "Portfolio Company Interventions for PE-backed firms navigating inflection points.",
    //     "Cohort-based Leadership Experiences designed to sharpen habits and performance."
    // ];

  //   const items = [
  //   {
  //     icon: ChartBarIcon,
  //     text: "Growth Performance Diagnostics for tech-services and consulting firms.",
  //   },
  //   {
  //     icon: SparklesIcon,
  //     text: "Executive Clarity Workshops for founders, CXOs, and business unit leaders.",
  //   },
  //   {
  //     icon: UserGroupIcon,
  //     text: "1:1 Leadership Advisory to help leaders think clearer and operate with purpose.",
  //   },
  //   {
  //     icon: PresentationChartLineIcon,
  //     text: "Portfolio Company Interventions for PE-backed firms navigating inflection points.",
  //   },
  //   {
  //     icon: AcademicCapIcon,
  //     text: "Cohort-based Leadership Experiences designed to sharpen habits and performance.",
  //   },
  // ];

  //23 Nov 2025

  const items = [
    {
      icon: ChartBarIcon,
      miniTitle: "Growth Diagnostics",
      // text: "Sharper visibility into how leaders think, decide, and operate — beyond dashboards and delivery metrics."
      text: "Reveals the mindset bottlenecks that impede growth. The gaps in thinking, habits, ownership, and purpose that dashboards never show."
    },
    {
      icon: SparklesIcon,
      miniTitle: "Clarity Workshops",
      text: "Deep-thinking sessions for founders and CXOs to align purpose, focus, and next-level priorities."
    },
    {
      icon: UserGroupIcon,
      miniTitle: "Leadership Advisory",
      text: "Targeted 1:1 guidance to help leaders to gain clarity, act with intention, orchestrate purposeful growth."
    },
    {
      icon: PresentationChartLineIcon,
      miniTitle: "Portfolio Interventions",
      // text: "Precision support for PE-backed firms navigating scale, transition, or leadership inflection points.",
      text: "Helps PE leaders uncover growth bottlenecks inside tech-led portcos, resolve client-engagement challenges and create clear, replicable performance roadmaps.",
    },
    {
      icon: AcademicCapIcon,
      miniTitle: "Leadership Cohorts",
      text: "Collective CxO cohort interventions to envision new growth and align on driving it together"
    },
    {
      icon: BriefcaseIcon, 
      miniTitle: "Role-Based Growth Cohorts",
      text: "Next-level role-based cohorts for Sales and Delivery Leaders to deepen account mining, client advisory, and influence"
    }
  ];



  return (

    <section className="relative overflow-hidden py-28 bg-black text-white">

      {/* 1. Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-950 to-orange-900/10"></div>

      {/* 2. Subtle Texture */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/asfalt-light.png')]"></div>

      {/* 3. Soft Vertical Glow */}
      <div
        className="
          pointer-events-none absolute left-1/2 top-0 -translate-x-1/2
          w-[500px] h-full bg-gradient-to-b
          from-orange-600/10 via-orange-500/5 to-transparent blur-[80px]
        "
      ></div>

      {/* 4. Reduced Dust Particles */}
      <div className="pointer-events-none absolute inset-0">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute w-[3px] h-[3px] bg-orange-300/15 rounded-full animate-advisory-dust"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${8 + Math.random() * 5}s`,
            }}
          ></div>
        ))}
      </div>

      {/* 5. Content */}
      <div className="relative z-20 max-w-6xl mx-auto px-6 text-center md:text-left">

        {/* Title */}
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-orange-500 mb-14"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          How Eternity Helps Leaders
        </motion.h2>

        {/* ===== Card Grid (Icon → Number → Title → Text, Center-Aligned) ===== */}
        <motion.div
        className="
            grid gap-10
            sm:grid-cols-2 
            lg:grid-cols-3
            text-gray-300
        "
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={{
            hidden: {},
            visible: {
            transition: { staggerChildren: 0.20 }
            }
        }}
        >
        {items.map((item, idx) => (
            <motion.div
            key={idx}
            variants={{
                hidden: { opacity: 0, y: 35 },
                visible: { opacity: 1, y: 0, transition: { duration: 1 } }
            }}
            className="
                group relative p-8 rounded-xl
                backdrop-blur-sm bg-white/5 
                border border-white/10 
                shadow-[0_0_25px_rgba(255,125,0,0.15)]
                transition-all duration-500
                cursor-default overflow-hidden
                flex flex-col items-center text-center
            "
            >
            {/* Parallax Gradient Layer */}
            <div
                className="
                absolute inset-0 opacity-0 group-hover:opacity-20 
                bg-gradient-to-br from-orange-600/20 via-orange-500/10 to-transparent
                transition-all duration-700 
                group-hover:translate-x-1 group-hover:-translate-y-1
                "
            ></div>

            {/* Icon — Centered */}
            <div
                className="
                h-14 w-14 rounded-full mb-5
                flex items-center justify-center
                bg-gradient-to-br from-orange-600/25 to-black/20
                border border-orange-500/25
                shadow-[0_0_15px_rgba(255,125,0,0.3)]
                "
            >
                <item.icon className="h-8 w-8 text-orange-400 drop-shadow-[0_0_8px_rgba(255,125,0,0.5)]" />
            </div>

            {/* Step Number — Centered */}
            <div className="text-lg md:text-xl font-semibold text-orange-500/80 mb-2 tracking-wider">
                {String(idx + 1).padStart(2, "0")}
            </div>

            {/* Mini Title — Centered */}
            <div className="text-lg font-semibold text-white mb-4 tracking-wide">
                {
                item.miniTitle
                }
            </div>

            {/* Description Text — Centered */}
            <p className="text-base leading-relaxed font-light relative z-10">
                {item.text}
            </p>
            </motion.div>
        ))}
        </motion.div>



      </div>

      {/* Motion Keyframes */}
      <style>{`
        @keyframes advisoryDustFloat {
          0% { transform: translateY(0) scale(0.7); opacity: 0.15; }
          50% { transform: translateY(-20px) scale(1); opacity: 0.32; }
          100% { transform: translateY(0) scale(0.7); opacity: 0.15; }
        }
        .animate-advisory-dust {
          animation: advisoryDustFloat linear infinite;
        }
      `}</style>

    </section>
    // <section className="relative overflow-hidden py-28 bg-black text-white">

    //   {/* --- 1. Background Gradient (Deep + Warm Bottom Glow) --- */}
    //   <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-950 to-orange-900/10"></div>

    //   {/* --- 2. Texture (Softer than other sections) --- */}
    //   <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/asfalt-light.png')]"></div>

    //   {/* --- 3. Subtle Vertical Glow Centered Behind Text --- */}
    //   <div
    //     className="
    //       pointer-events-none absolute left-1/2 top-0 -translate-x-1/2
    //       w-[500px] h-full bg-gradient-to-b
    //       from-orange-600/10 via-orange-500/5 to-transparent blur-[80px]
    //     "
    //   ></div>

    //   {/* --- 4. Light Dust Particles (Calm, Sparse) --- */}
    //   <div className="pointer-events-none absolute inset-0">
    //     {[...Array(180)].map((_, i) => (
    //       <div
    //         key={i}
    //         className="absolute w-[3px] h-[3px] bg-orange-300/15 rounded-full animate-advisory-dust"
    //         style={{
    //           top: `${Math.random() * 100}%`,
    //           left: `${Math.random() * 100}%`,
    //           animationDelay: `${Math.random() * 3}s`,
    //           animationDuration: `${7 + Math.random() * 4}s`,
    //         }}
    //       ></div>
    //     ))}
    //   </div>

    //   {/* --- 5. Content Container --- */}
    //   <div className="relative z-20 max-w-6xl mx-auto px-6 text-center md:text-left">

    //     {/* Title */}
    //     <motion.h2
    //       className="text-3xl md:text-4xl font-bold text-orange-500 mb-10"
    //       initial={{ opacity: 0, y: 30 }}
    //       whileInView={{ opacity: 1, y: 0 }}
    //       viewport={{ once: true }}
    //       transition={{ duration: 1 }}
    //     >
    //       How Eternity Helps Leaders
    //     </motion.h2>

    //     {/* List */}
    //     <motion.div
    //       className="space-y-6 text-lg text-gray-300 leading-relaxed max-w-4xl font-extralight"
    //       initial="hidden"
    //       whileInView="visible"
    //       viewport={{ once: true }}
    //       variants={{
    //         hidden: {},
    //         visible: {
    //           transition: { staggerChildren: 0.2 }
    //         }
    //       }}
    //     >
    //       {items.map((item, idx) => (
    //         <motion.div
    //           key={idx}
    //           variants={{
    //             hidden: { opacity: 0, x: -20 },
    //             visible: { opacity: 1, x: 0, transition: { duration: 0.9 } }
    //           }}
    //           className="flex items-start gap-4"
    //         >
    //           {/* Icon */}
    //           <div className="mt-2 h-[12px] w-[12px] bg-orange-500 rounded-full shadow-[0_0_10px_rgba(255,125,0,0.4)]"></div>

    //           {/* Text */}
    //           <p>{item}</p>
    //         </motion.div>
    //       ))}
    //     </motion.div>
    //   </div>

    //   {/* --- Motion Keyframes --- */}
    //   <style>{`
    //     @keyframes advisoryDustFloat {
    //       0% { transform: translateY(0) scale(0.7); opacity: 0.15; }
    //       50% { transform: translateY(-20px) scale(1); opacity: 0.35; }
    //       100% { transform: translateY(0) scale(0.7); opacity: 0.15; }
    //     }
    //     .animate-advisory-dust {
    //       animation: advisoryDustFloat linear infinite;
    //     }
    //   `}</style>

    // </section>
  );
}